import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { Holding } from "models";

const component = "HoldingsDashboard";

export const HoldingsQueryKeys = {
  list: backendQueryKey<Holding[]>({ component, baseUrl: ENV.holdingBaseURL, endpoint: "/holdings/list" })
};
